import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c579812"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "yomokkaNavi__inner",
  style: {"justify-content":"flex-start"}
}
const _hoisted_2 = { class: "yomokkaNavi__lists" }
const _hoisted_3 = { class: "yomokkaNavi__link_icon" }
const _hoisted_4 = { class: "yomokkaNavi__link_text" }
const _hoisted_5 = { class: "yomokkaNavi__options" }
const _hoisted_6 = {
  key: 0,
  class: "yomokkaNavi__point"
}
const _hoisted_7 = { class: "yomokkaNavi__point_inner" }
const _hoisted_8 = { class: "yomokkaNavi__point_numberArea" }
const _hoisted_9 = { class: "yomokkaNavi__point_number" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "yomokkaNavi__point_text" }, "ポイント", -1))
const _hoisted_11 = {
  key: 1,
  class: "yomokkaNavi__inner"
}
const _hoisted_12 = { class: "yomokkaNavi__lists" }
const _hoisted_13 = { class: "yomokkaNavi__link_icon" }
const _hoisted_14 = { class: "yomokkaNavi__link_text" }
const _hoisted_15 = { class: "yomokkaNavi__options" }
const _hoisted_16 = {
  key: 0,
  class: "yomokkaNavi__point"
}
const _hoisted_17 = { class: "yomokkaNavi__point_inner" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "yomokkaNavi__point_text" }, "ポイント", -1))
const _hoisted_19 = { class: "yomokkaNavi__point_numberArea" }
const _hoisted_20 = { class: "yomokkaNavi__point_number" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yomokkaNavi__point_text" }, "P", -1))
const _hoisted_22 = { class: "yomokkaNavi__keyboard" }
const _hoisted_23 = { class: "yomokkaNavi__link_icon" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yomokkaNavi__link_text" }, "キーボード", -1))
const _hoisted_26 = {
  key: 0,
  class: "themeModal__wrap"
}

import { inject, withDefaults, ref, computed, Ref } from 'vue'
import { useRoute, onBeforeRouteUpdate } from 'vue-router'

import { GA_EVENT_VALUES } from '@/constants/ga'
import { injectionKeys } from '@/constants/injectionKeys'
import { useKeyboardStore } from '@/store/keyboard'
import GaHelper from '@/helpers/GaHelper'

import AnimationPushToShadow from '@/components/AnimationPushToShadow/AnimationPushToShadow.vue'
import AppImage from '@/components/AppImage/AppImage.vue'
import ThemeSelect from '@/components/ThemeSelect/ThemeSelect.vue'

type Props = {
  points?: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'YomokkaNavi',
  props: {
    points: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { points: number }

/**
 * YomokkaNavi.
 */
const isSharedId = inject<Ref<boolean>>(injectionKeys.isSharedId)!
const isFixedIp = inject<Ref<boolean>>(injectionKeys.isFixedIp)!
const isWhitelist = inject<Ref<boolean>>(injectionKeys.isWhitelist)!
const isNextGiga = inject<Ref<boolean>>(injectionKeys.isNextGiga)!



const route = useRoute()
const isTopPage = computed(() => route.path === '/')

// テーマ
const isVisibleThemeSelect = ref(false)
const showThemeModal = computed(() => isVisibleThemeSelect.value)
const toggleThemeModal = (value?: boolean) => {
  isVisibleThemeSelect.value =
    typeof value !== 'undefined' ? value : !isVisibleThemeSelect.value
}

// キーボードボタン
const keyboardStore = useKeyboardStore()
const onClickKeyboard = () => {
  toggleKeyboard()
  GaHelper.registerGaEvent(GA_EVENT_VALUES.navigation.keyboard)
}
const toggleKeyboard = () => {
  // toggleThemeModal(false)
  keyboardStore.toggleShow()
}
const closeKeyboard = () => {
  keyboardStore.setShow(false)
}
// 他ページへ遷移する場合はキーボード閉じる
onBeforeRouteUpdate((to) => {
  // ヘルプモーダルの場合は閉じない
  if (to.path === '/help') return
  closeKeyboard()
})

// メニュー
const isMenuItemActive = computed(() => {
  return (name: string) => {
    if (!showThemeModal.value) {
      return name === route.name
    }
    return name === 'Theme'
  }
})

// eslint-disable-next-line max-lines-per-function
const menu = computed(() => {
  const list = [
    {
      visible: !isWhitelist.value,
      name: 'Top',
      displayName: 'トップ',
      path: '/',
      icon: {
        src: require('@/assets/image/navi/navi_top.svg'),
        srcActive: require('@/assets/image/navi/navi_top_active.svg'),
      },
      onClick: () => {
        toggleThemeModal(false)
        closeKeyboard()
        GaHelper.registerGaEvent(GA_EVENT_VALUES.navigation.top)
      },
    },
    {
      visible: true,
      name: 'Bookshelf',
      displayName: '本だな',
      path: '/bookshelf',
      icon: {
        src: require('@/assets/image/navi/navi_bookshelf.svg'),
        srcActive: require('@/assets/image/navi/navi_bookshelf_active.svg'),
      },
      onClick: () => {
        toggleThemeModal(false)
        closeKeyboard()
        GaHelper.registerGaEvent(GA_EVENT_VALUES.navigation.bookshelf)
      },
    },
    {
      visible: !isSharedId.value && !isFixedIp.value && !isWhitelist.value,
      name: 'Theme',
      displayName: 'テーマ',
      icon: {
        src: require('@/assets/image/navi/navi_theme.svg'),
        srcActive: require('@/assets/image/navi/navi_theme_active.svg'),
      },
      onClick: () => {
        toggleThemeModal()
        // closeKeyboard()
        GaHelper.registerGaEvent(GA_EVENT_VALUES.navigation.theme)
      },
    },
    {
      visible: !isNextGiga.value && !isWhitelist.value,
      name: 'Information',
      displayName: 'おしらせ',
      path: '/information',
      icon: {
        src: require('@/assets/image/navi/navi_information.svg'),
        srcActive: require('@/assets/image/navi/navi_information_active.svg'),
      },
      onClick: () => {
        toggleThemeModal(false)
        closeKeyboard()
        GaHelper.registerGaEvent(GA_EVENT_VALUES.navigation.information)
      },
    },
    {
      visible: !isNextGiga.value && !isWhitelist.value,
      name: 'keyboard',
      displayName: 'キーボード',
      icon: {
        src: require('@/assets/image/navi/navi_keyboard.svg'),
      },
      onClick: () => onClickKeyboard(),
    },
    {
      visible: true,
      name: 'Help',
      displayName: 'ヘルプ',
      path: '/help',
      icon: {
        src: require('@/assets/image/navi/navi_help.svg'),
        srcActive: require('@/assets/image/navi/navi_help_active.svg'),
      },
      onClick: () => {
        toggleThemeModal(false)
        closeKeyboard()
        GaHelper.registerGaEvent(GA_EVENT_VALUES.navigation.help)
      },
    },
  ]

  return list.filter((item) => item.visible)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["yomokkaNavi", { 'is-themeShow': isVisibleThemeSelect.value, 'with-nextgiga': _unref(isNextGiga) || _unref(isWhitelist)}])
  }, [
    (!_unref(isNextGiga) && !_unref(isWhitelist))
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.name,
                  class: _normalizeClass(["navi__item", `yomokkaNavi__list_${item.name.toLowerCase()}`])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.path ? 'router-link' : 'button'), _mergeProps(item.path ? { to: item.path } : {}, {
                    class: ["yomokkaNavi__link animationLink", { 'is-active': _unref(isMenuItemActive)(item.name) }],
                    onClick: item.onClick
                  }), {
                    default: _withCtx(() => [
                      _createVNode(AnimationPushToShadow, {
                        rounded: "circle",
                        class: "yomokkaNavi__link_button"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_3, [
                            _createVNode(AppImage, {
                              src: 
                      _unref(isMenuItemActive)(item.name)
                        ? item.icon.srcActive
                        : item.icon.src
                    ,
                              alt: "",
                              width: "40",
                              height: "40"
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.displayName), 1)
                    ]),
                    _: 2
                  }, 1040, ["class", "onClick"]))
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (!_unref(isSharedId) && !_unref(isFixedIp) && !_unref(isWhitelist) && __props.points !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(__props.points), 1)
                    ]),
                    _hoisted_10
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("nav", _hoisted_11, [
          _createElementVNode("div", null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isTopPage) ? 'h1' : 'div'), { class: "yomokkaNavi__logo" }, {
              default: _withCtx(() => [
                _createVNode(AppImage, {
                  src: require('@/assets/image/logo_yomokka.svg'),
                  alt: "Yomokka!",
                  width: "60",
                  height: "13"
                }, null, 8, ["src"])
              ]),
              _: 1
            })),
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.name,
                  class: _normalizeClass(["navi__item", `yomokkaNavi__list_${item.name.toLowerCase()}`])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.path ? 'router-link' : 'button'), _mergeProps(item.path ? { to: item.path } : {}, {
                    class: ["yomokkaNavi__link animationLink", { 'is-active': _unref(isMenuItemActive)(item.name) }],
                    onClick: item.onClick
                  }), {
                    default: _withCtx(() => [
                      _createVNode(AnimationPushToShadow, {
                        rounded: "circle",
                        class: "yomokkaNavi__link_button"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_13, [
                            _createVNode(AppImage, {
                              src: 
                      _unref(isMenuItemActive)(item.name)
                        ? item.icon.srcActive
                        : item.icon.src
                    ,
                              alt: "",
                              width: "40",
                              height: "40"
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(item.displayName), 1)
                    ]),
                    _: 2
                  }, 1040, ["class", "onClick"]))
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (!_unref(isSharedId) && !_unref(isFixedIp) && !_unref(isWhitelist) && __props.points !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("p", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(__props.points), 1),
                      _hoisted_21
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "yomokkaNavi__link animationLink",
                onClick: onClickKeyboard
              }, [
                _createVNode(AnimationPushToShadow, {
                  rounded: "circle",
                  class: "yomokkaNavi__link_button"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_23, [
                      _createElementVNode("img", {
                        src: require(`@/assets/image/navi/navi_keyboard.svg`),
                        alt: "",
                        width: "40",
                        height: "40"
                      }, null, 8, _hoisted_24)
                    ])
                  ]),
                  _: 1
                }),
                _hoisted_25
              ])
            ])
          ])
        ])),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (isVisibleThemeSelect.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(ThemeSelect, {
                open: _unref(showThemeModal),
                "onUpdate:theme": toggleThemeModal
              }, null, 8, ["open"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})